export const TEXT_FIELD_SIZE = 32;
